<template>
    <!-- 
    Dashboard Layout
    ---------------- 
    -->
    <!-- Sidebar -->
    
    <side-bar></side-bar>

    <!-- Global Modals -->
    <job-edit v-if="showJobModal" @close="showJobModal = false" />
    <assignment-edit v-if="showAssignmentModal" @close="showAssignmentModal = false" />

    <!-- Main Content -->
    <div class="main-content">
        <!-- Header Section -->
        <header class="header-section" v-if="true || $route.matched.some(record => record.components && record.components.header)">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <button class="btn btn-sm btn-outline-secondary d-inline-block d-md-none" @click="toggleSidebar()">
                  <i class="fas fa-bars mx-1"></i>
                </button>
                <router-view name="header"></router-view>
              </div>
              <user-dropdown />
            </div>
        </header>

        <!-- Main Section -->
        <main class="main-section">
            <div class="main-wrap">
                <div class="container-fluid">
                    <router-view name="page"></router-view>
                </div>
            </div>
            <!-- Footer Section -->
            <div class="container-fluid px-0 mt-auto">
                <div class="footer-section">
                    <p class="mb-0">
                        &copy; 2025 - 7th Level Technologies. 
                        All rights reserved.
                    </p>
                </div>
            </div>
        </main>

    </div>
    
</template>

<script setup>
    import { ref } from "vue";
    import { RouterView, RouterLink } from 'vue-router';
    import SideBar from "@/components/Shared/Sidebar.vue";
    import UserDropdown from "@/components/Shared/UserDropdown.vue";
    import JobEdit from "@/components/Jobs/JobEdit.vue";
    import AssignmentEdit from "@/components/Time/AssignmentEdit.vue";
    import Emitter from "@/services/Emitter";
    
    
    import AppHeader from "@/components/Shared/AppHeader.vue";
    import AppFooter from "@/components/Shared/AppFooter.vue";
    import KtOffcanvas from "@/components/UI/KtOffcanvas.vue";
    import KtLoading from '@/components/UI/KtLoading.vue';
    import Events from "@/services/Emitter";
    import Helper from "@/services/Helper";
    
    const showSidebar = ref(false);
    const loading = ref(0);
    const version = ref(0);
    const showJobModal = ref(false);
    const showAssignmentModal = ref(false);
    
    const refresh = () =>
    {
        window.location.reload(true);
    };
    
    const toggleSidebar = () =>
    {
      Emitter.emit("sidebar");
    }
    
    // Listen for global modal events
    Emitter.on("open-job-modal", () => {
      showJobModal.value = true;
    });

    Emitter.on("open-assignment-modal", () => {
      showAssignmentModal.value = true;
    });
    
    
</script>

<style scoped>
    
    
    .main-content {
        margin-left: 300px;
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    @media (max-width: 768px) {
      .main-content {
        margin-left: 0;
      }
    }

      .header-section {
        padding: 1.5rem;
        background-color: #f8f9fa;
        border-bottom: 1px solid #dee2e6;
    }
    .main-section {
        flex: 1;
        background-color: #ffffff;
        overflow-y:auto;
        display: flex;
        flex-direction: column;
    }

    .main-wrap {
        padding: 1.5rem;
    }

    .footer-section {
        padding: 1rem;
        background-color: #f8f9fa;
        border-top: 1px solid #dee2e6;
        text-align: center;
        color: #6c757d;
    }
    .search-bar {
        max-width: 400px;
    }


</style>
    